<div class="card">
    <div class="card-header">
      <h4>Transaction Master Rule</h4>
    </div>
    <div class="card-body m-0">
        <div class="row d-flex">
            <div class="form-group col-md-3">
              <label class="col-form-label" for="userType">User Type</label>                      
              <ng-select (change)="userTypeChange($event)" id="userType" placeholder="Select User Type" [(ngModel)]="userType" name="userType">
                <ng-option *ngFor="let country of userTypeList" value="{{country.value}}">{{country.name}}</ng-option>
              </ng-select>   
            </div>
            <div class="form-group col-md-3" *ngIf="userType == 'AGENT'">
                <label class="col-form-label" for="selectedAgent">Agent</label>                      
                <ng-select id="selectedAgent" (change)="agentChange($event)" placeholder="Select Agent" [(ngModel)]="selectedAgent">
                  <ng-option *ngFor="let agent of agentList" value="{{agent.value}}">{{agent.name}}</ng-option>
                </ng-select>   
            </div>
            <div class="form-group col-md-9" *ngIf="userType == 'DEFAULT_CUSTOMER'">
              <div class="text-right">
                <button type="button" class="btn btn-primary" (click)="emailConfigModal('CUSTOMER')" >Email Configuration For Customer</button>
              </div>
            </div>
            <div class="form-group col-md-6" *ngIf="userType == 'AGENT'">
              <div class="text-right">
                <button type="button" class="btn btn-primary" (click)="emailConfigModal('AGENT')" >Email Configuration For Agent</button>
              </div>
          </div>
            <br>
        </div>
        
        <div class="row d-flex" *ngIf="userType == 'DEFAULT_CUSTOMER' || (selectedAgent != '' && selectedAgent != undefined) ">
            <div class="mt-2">
              <form #addAML001="ngForm" (ngSubmit)="addAML001Rule('aml001',addAML001.value)" [formGroup]="AML001">
                <ngb-accordion>
                  <ngb-panel>
                    <ng-template ngbPanelTitle>
                      <h5>AML001 | One Customer Sending Funds To Multiple Receiver In A Set Period</h5>
                    </ng-template>
                    <ng-template ngbPanelContent>
                        <div>
                          <div class="row d-flex">
                            <div class="form-group col-md-2" >
                              <input class="form-check-input" id="notify" value="true" formControlName="notify" name="notify" style="margin-top: 10px; margin-left: 5px;" type="checkbox">
                              <label class=" col-form-label form-check-label" style="margin-left: 30px;"><i class="feather icon-bell text-warning"></i> Notify</label>
                            </div>
                            <div class="form-group col-md-1" >
                                <input class="form-check-input" id="block" formControlName="block" name="block" style="margin-top: 10px;" type="checkbox">
                                <label class=" col-form-label form-check-label" style="margin-left: 5px;"><i class="feather icon-x-circle text-danger"></i> Block</label>
                            </div>
                          </div>
                            <div class="row d-flex">
                                <div class="form-group col-md-2">
                                    <label class="col-form-label" >Number of Receivers :</label>                         
                                </div>
                                <div class="form-group col-md-3" >
                                  <p >Daily Count</p> 
                                  <input type="text" id="dailyCount" autocomplete="off"  class="form-control" required formControlName="dailyCount" placeholder="Enter Daily Count" [ngClass]="{'is-invalid':submittedAML001 && AML001.controls.dailyCount.errors}" name="dailyCount" onkeypress="return event.keyCode === 8 || event.charCode >= 48 && event.charCode <= 57">
                                  <div class="invalid-feedback">
                                    Daily Count is required
                                  </div>
                                </div>
                                <div class="form-group col-md-3" >
                                  <p>Weekly Count</p> 
                                  <input type="text" id="weeklyCount" autocomplete="off"  class="form-control" required formControlName="weeklyCount" placeholder="Enter Weekly Count" [ngClass]="{'is-invalid':submittedAML001 && AML001.controls.weeklyCount.errors}" name="weeklyCount" onkeypress="return event.keyCode === 8 || event.charCode >= 48 && event.charCode <= 57">
                                  <div class="invalid-feedback">
                                    Weekly Count is required
                                  </div>
                                </div>
                                <div class="form-group col-md-3" >
                                  <p>Monthly Count</p> 
                                  <input type="text" id="monthlyCount" autocomplete="off"  class="form-control" required formControlName="monthlyCount" placeholder="Enter Monthly Count" [ngClass]="{'is-invalid':submittedAML001 && AML001.controls.monthlyCount.errors}" name="monthlyCount" onkeypress="return event.keyCode === 8 || event.charCode >= 48 && event.charCode <= 57">
                                  <div class="invalid-feedback">
                                    Monthly Count is required
                                  </div>
                                </div>
                            </div>
                            <div class="text-right">
                                <div class="form-group col-md-12">
                                    <button type="submit" class="btn btn-primary">Save</button>
                                </div>
                            </div>
                        </div>
                    </ng-template>
                  </ngb-panel>
                </ngb-accordion>
              </form>
              </div>

              <div class="mt-2">
                <form #addAML002="ngForm" (ngSubmit)="addAML002Rule('aml002',addAML002.value)" [formGroup]="AML002">
                <ngb-accordion>
                  <ngb-panel>
                    <ng-template ngbPanelTitle>
                      <h5>AML002 | One Customer Receiving Funds From Multiple Senders In A Set Period</h5>
                    </ng-template>
                    <ng-template ngbPanelContent>
                      <div>
                        <div class="row d-flex">
                          <div class="form-group col-md-2" >
                            <input class="form-check-input" id="notify" formControlName="notify" name="notify" style="margin-top: 10px; margin-left: 5px;" type="checkbox">
                            <label class=" col-form-label form-check-label" style="margin-left: 30px;"><i class="feather icon-bell text-warning"></i> Notify</label>
                          </div>
                          <div class="form-group col-md-1" >
                              <input class="form-check-input" id="block" formControlName="block" name="block" style="margin-top: 10px;" type="checkbox">
                              <label class=" col-form-label form-check-label" style="margin-left: 5px;"><i class="feather icon-x-circle text-danger"></i> Block</label>
                          </div>
                        </div>
                          <div class="row d-flex">
                              <div class="form-group col-md-2">
                                  <label class="col-form-label" for="userType">Number of Senders</label>                         
                              </div>
                              <div class="form-group col-md-3" >
                                <p>Daily Count</p> 
                                <input type="text" id="dailyCount" autocomplete="off" class="form-control" required formControlName="dailyCount" placeholder="Enter Daily Count" [ngClass]="{'is-invalid':submittedAML002 && AML002.controls.dailyCount.errors}" name="dailyCount" onkeypress="return event.keyCode === 8 || event.charCode >= 48 && event.charCode <= 57">
                                <div class="invalid-feedback">
                                  Daily Count is required
                                </div>
                              </div>
                              <div class="form-group col-md-3" >
                                <p>Weekly Count</p> 
                                <input type="text" id="weeklyCount" autocomplete="off" class="form-control" required formControlName="weeklyCount" placeholder="Enter Weekly Count" [ngClass]="{'is-invalid':submittedAML002 && AML002.controls.weeklyCount.errors}" name="weeklyCount" onkeypress="return event.keyCode === 8 || event.charCode >= 48 && event.charCode <= 57">
                                <div class="invalid-feedback">
                                  Weekly Count is required
                                </div>
                              </div>
                              <div class="form-group col-md-3" >
                                <p>Monthly Count</p> 
                                <input type="text" id="monthlyCount" autocomplete="off" class="form-control" required formControlName="monthlyCount" placeholder="Enter Monthly Count" [ngClass]="{'is-invalid':submittedAML002 && AML002.controls.monthlyCount.errors}" name="monthlyCount" onkeypress="return event.keyCode === 8 || event.charCode >= 48 && event.charCode <= 57">
                                <div class="invalid-feedback">
                                  Monthly Count is required
                                </div>
                              </div>
                          </div>
                          <div class="text-right">
                              <div class="form-group col-md-12">
                                  <button type="submit" class="btn btn-primary">Save</button>
                              </div>
                          </div>
                      </div>
                    </ng-template>
                  </ngb-panel>
                </ngb-accordion>
              </form>
              </div>

              <div class="mt-2">
                <form #addAML003="ngForm" (ngSubmit)="addAML003Rule('aml003',addAML003.value)" [formGroup]="AML003">
                <ngb-accordion>
                  <ngb-panel>
                    <ng-template ngbPanelTitle>
                      <h5>AML003 | Any Transaction Greater Than The Set Threshold in round off Amount Done By A Sender</h5>
                    </ng-template>
                    <ng-template ngbPanelContent>
                      <div>
                        <div class="row d-flex">
                          <div class="form-group col-md-2" >
                            <input class="form-check-input" id="notify" formControlName="notify"  name="notify" style="margin-top: 10px; margin-left: 5px;" type="checkbox">
                            <label class=" col-form-label form-check-label" style="margin-left: 30px;"><i class="feather icon-bell text-warning"></i> Notify</label>
                          </div>
                          <div class="form-group col-md-1" >
                              <input class="form-check-input" id="block" formControlName="block"  name="block" style="margin-top: 10px;" type="checkbox">
                              <label class=" col-form-label form-check-label" style="margin-left: 5px;"><i class="feather icon-x-circle text-danger"></i> Block</label>
                          </div>
                        </div>
                          <div class="row d-flex">
                              <div class="form-group col-md-2">
                                  <label class="col-form-label" for="userType">Number of Count</label>                         
                              </div>
                              <div class="form-group col-md-3" >
                                <p>Day Count</p> 
                                <input type="text" id="dailyCount" autocomplete="off" class="form-control" required formControlName="dailyCount" placeholder="Enter Day Count" [ngClass]="{'is-invalid':submittedAML003 && AML003.controls.dailyCount.errors}"  name="dailyCount" onkeypress="return event.keyCode === 8 || event.charCode >= 48 && event.charCode <= 57">
                                <div class="invalid-feedback">
                                  Day Count is required
                                </div>
                              </div>
                              <div class="form-group col-md-3" >
                                <p>Week Count</p> 
                                <input type="text" id="weeklyCount" autocomplete="off" class="form-control" required formControlName="weeklyCount" placeholder="Enter Week Count" [ngClass]="{'is-invalid':submittedAML003 && AML003.controls.weeklyCount.errors}"  name="weeklyCount" onkeypress="return event.keyCode === 8 || event.charCode >= 48 && event.charCode <= 57">
                                <div class="invalid-feedback">
                                  Week Count is required
                                </div>
                              </div>
                              <div class="form-group col-md-3" >
                                <p>Month Count</p> 
                                <input type="text" id="monthlyCount" autocomplete="off" class="form-control" required formControlName="monthlyCount" placeholder="Enter Month Count" [ngClass]="{'is-invalid':submittedAML003 && AML003.controls.monthlyCount.errors}"  name="monthlyCount" onkeypress="return event.keyCode === 8 || event.charCode >= 48 && event.charCode <= 57">
                                <div class="invalid-feedback">
                                  Month Count is required
                                </div>
                              </div>
                          </div>
                          <div class="row d-flex">
                            <div class="form-group col-md-2">
                                <label class="col-form-label" for="userType">Threshold Percentage</label>                         
                            </div>
                            <div class="form-group col-md-3" >
                              <p>Daily Percentage</p> 
                              <input type="text" id="dailyThresholdPercentage" maxlength="3" autocomplete="off" class="form-control" required formControlName="dailyThresholdPercentage" placeholder="Enter Daily Percentage" [ngClass]="{'is-invalid':submittedAML003 && AML003.controls.dailyThresholdPercentage.errors}"  name="dailyThresholdPercentage" onkeypress="return event.keyCode === 8 || event.charCode >= 48 && event.charCode <= 57">
                              <div class="invalid-feedback">
                                Daily Percentage is required
                              </div>
                            </div>
                            <div class="form-group col-md-3" >
                              <p>Weekly Percentage</p>
                              <input type="text" id="weeklyThresholdPercentage" maxlength="3" autocomplete="off" class="form-control" required formControlName="weeklyThresholdPercentage" placeholder="Enter Weekly Percentage" [ngClass]="{'is-invalid':submittedAML003 && AML003.controls.weeklyThresholdPercentage.errors}"  name="weeklyThresholdPercentage" onkeypress="return event.keyCode === 8 || event.charCode >= 48 && event.charCode <= 57">
                              <div class="invalid-feedback">
                                Weekly Percentage is required
                              </div>
                            </div>
                            <div class="form-group col-md-3" >
                              <p>Monthly Percentage</p>
                              <input type="text" id="monthlyThresholdPercentage" maxlength="3" autocomplete="off" class="form-control" required formControlName="monthlyThresholdPercentage" placeholder="Enter Monthly Percentage" [ngClass]="{'is-invalid':submittedAML003 && AML003.controls.monthlyThresholdPercentage.errors}"  name="monthlyThresholdPercentage" onkeypress="return event.keyCode === 8 || event.charCode >= 48 && event.charCode <= 57">
                              <div class="invalid-feedback">
                                Monthly Percentage is required
                              </div>
                            </div>
                          </div>
                          <div class="text-right">
                              <div class="form-group col-md-12">
                                  <button type="submit" class="btn btn-primary">Save</button>
                              </div>
                          </div>
                      </div>
                    </ng-template>
                  </ngb-panel>
                </ngb-accordion>
                </form>
              </div>

              <!-- <div class="mt-2">
                <form #addAML004="ngForm" (ngSubmit)="addAML004Rule('aml004',addAML004.value)" [formGroup]="AML004">
                <ngb-accordion>
                  <ngb-panel>
                    <ng-template ngbPanelTitle>
                      <h5>AML004 | Any Transaction Greater Than The Set Threshold in round off Amount Received By A Receiver</h5>
                    </ng-template>
                    <ng-template ngbPanelContent>
                      <div>
                        <div class="row d-flex">
                          <div class="form-group col-md-2" >
                            <input class="form-check-input" id="notify" formControlName="notify"  name="notify" style="margin-top: 10px; margin-left: 5px;" type="checkbox">
                            <label class=" col-form-label form-check-label" style="margin-left: 30px;"><i class="feather icon-bell text-warning"></i> Notify</label>
                          </div>
                          <div class="form-group col-md-1" >
                              <input class="form-check-input" id="block" formControlName="block"  name="block" style="margin-top: 10px;" type="checkbox">
                              <label class=" col-form-label form-check-label" style="margin-left: 5px;"><i class="feather icon-x-circle text-danger"></i> Block</label>
                          </div>
                        </div>
                        <div class="row d-flex">
                          <div class="form-group col-md-2">
                              <label class="col-form-label" for="userType">Number of Count</label>                         
                          </div>
                          <div class="form-group col-md-3" >
                            <p>Day Count</p>
                            <input type="text" id="dailyCount" autocomplete="off" class="form-control" required formControlName="dailyCount" placeholder="Enter Day Count" [ngClass]="{'is-invalid':submittedAML004 && AML004.controls.dailyCount.errors}"  name="dailyCount" onkeypress="return event.keyCode === 8 || event.charCode >= 48 && event.charCode <= 57">
                            <div class="invalid-feedback">
                              Day Count is required
                            </div>
                          </div>
                          <div class="form-group col-md-3" >
                            <p>Week Count</p>
                            <input type="text" id="weeklyCount" autocomplete="off" class="form-control" required formControlName="weeklyCount" placeholder="Enter Week Count" [ngClass]="{'is-invalid':submittedAML004 && AML004.controls.weeklyCount.errors}"  name="weeklyCount" onkeypress="return event.keyCode === 8 || event.charCode >= 48 && event.charCode <= 57">
                            <div class="invalid-feedback">
                              Week Count is required
                            </div>
                          </div>
                          <div class="form-group col-md-3" >
                            <p>Month Count</p>
                            <input type="text" id="monthlyCount" autocomplete="off" class="form-control" required formControlName="monthlyCount" placeholder="Enter Month Count" [ngClass]="{'is-invalid':submittedAML004 && AML004.controls.monthlyCount.errors}"  name="monthlyCount" onkeypress="return event.keyCode === 8 || event.charCode >= 48 && event.charCode <= 57">
                            <div class="invalid-feedback">
                              Month Count is required
                            </div>
                          </div>
                      </div>
                      <div class="row d-flex">
                        <div class="form-group col-md-2">
                            <label class="col-form-label" for="userType">Threshold Percentage</label>                         
                        </div>
                        <div class="form-group col-md-3" >
                          <p>Daily Percentage</p>
                          <input type="text" id="dailyThresholdPercentage" autocomplete="off" class="form-control" required formControlName="dailyThresholdPercentage" placeholder="Enter Daily Percentage" [ngClass]="{'is-invalid':submittedAML004 && AML004.controls.dailyThresholdPercentage.errors}"  name="dailyThresholdPercentage" onkeypress="return event.keyCode === 8 || event.charCode >= 48 && event.charCode <= 57">
                          <div class="invalid-feedback">
                            Daily Percentage is required
                          </div>
                        </div>
                        <div class="form-group col-md-3" >
                          <p>Weekly Percentage</p>
                          <input type="text" id="weeklyThresholdPercentage" autocomplete="off" class="form-control" required formControlName="weeklyThresholdPercentage" placeholder="Enter Weekly Percentage" [ngClass]="{'is-invalid':submittedAML004 && AML004.controls.weeklyThresholdPercentage.errors}"  name="weeklyThresholdPercentage" onkeypress="return event.keyCode === 8 || event.charCode >= 48 && event.charCode <= 57">
                          <div class="invalid-feedback">
                            Weekly Percentage is required
                          </div>
                        </div>
                        <div class="form-group col-md-3" >
                          <p>Monthly Percentage</p>
                          <input type="text" id="monthlyThresholdPercentage" autocomplete="off" class="form-control" required formControlName="monthlyThresholdPercentage" placeholder="Enter Monthly Percentage" [ngClass]="{'is-invalid':submittedAML004 && AML004.controls.monthlyThresholdPercentage.errors}"  name="monthlyThresholdPercentage" onkeypress="return event.keyCode === 8 || event.charCode >= 48 && event.charCode <= 57">
                          <div class="invalid-feedback">
                            Monthly Percentage is required
                          </div>
                        </div>
                      </div>
  
                          <div class="text-right">
                              <div class="form-group col-md-12">
                                  <button type="submit" class="btn btn-primary">Save</button>
                              </div>
                          </div>
                      </div>
                    </ng-template>
                  </ngb-panel>
                </ngb-accordion>
                </form>
              </div> -->

              <div class="mt-2">
                <form #addAML005Sender="ngForm" (ngSubmit)="addAML005SenderRule('aml005Amount',addAML005Sender.value)" [formGroup]="AML005Amount">
                <ngb-accordion>
                  <ngb-panel>
                    <ng-template ngbPanelTitle>
                      <h5>AML005.1 | Transactions More Than A Set Amount Done By High Risk National Sender</h5>
                    </ng-template>
                    <ng-template ngbPanelContent>
                      <div>
                        <div class="row d-flex">
                          <div class="form-group col-md-2" >
                            <input class="form-check-input" id="notify" formControlName="notify"  name="notify" style="margin-top: 10px; margin-left: 5px;" type="checkbox">
                            <label class=" col-form-label form-check-label" style="margin-left: 30px;"><i class="feather icon-bell text-warning"></i> Notify</label>
                          </div>
                          <div class="form-group col-md-1" >
                              <input class="form-check-input" id="block" formControlName="block"  name="block" style="margin-top: 10px;" type="checkbox">
                              <label class=" col-form-label form-check-label" style="margin-left: 5px;"><i class="feather icon-x-circle text-danger"></i> Block</label>
                          </div>
                        </div>
                          <div class="row d-flex">
                              <div class="form-group col-md-2">
                                  <label class="col-form-label" for="userType">Threshold Amount</label>                         
                              </div>
                              <div class="form-group col-md-3" >
                                <p>Daily Amount</p>
                                <input type="text" id="dailyAmount" autocomplete="off" class="form-control" required formControlName="dailyAmount" placeholder="Enter Daily Amount" [ngClass]="{'is-invalid':submittedAML005Amount && AML005Amount.controls.dailyAmount.errors}"  name="dailyAmount" onkeypress="return event.keyCode === 8 || event.charCode >= 48 && event.charCode <= 57">
                                <div class="invalid-feedback">
                                  Daily Amount is required
                                </div>
                              </div>
                              <div class="form-group col-md-3" >
                                <p>Weekly Amount</p>
                                <input type="text" id="weeklyAmount" autocomplete="off" class="form-control" required formControlName="weeklyAmount" placeholder="Enter Weekly Amount" [ngClass]="{'is-invalid':submittedAML005Amount && AML005Amount.controls.weeklyAmount.errors}"  name="weeklyAmount" onkeypress="return event.keyCode === 8 || event.charCode >= 48 && event.charCode <= 57">
                                <div class="invalid-feedback">
                                  Weekly Amount is required
                                </div>
                              </div>
                              <div class="form-group col-md-3" >
                                <p>Monthly Amount</p>
                                <input type="text" id="monthlyAmount" autocomplete="off" class="form-control" required formControlName="monthlyAmount" placeholder="Enter Monthly Amount" [ngClass]="{'is-invalid':submittedAML005Amount && AML005Amount.controls.monthlyAmount.errors}"  name="monthlyAmount" onkeypress="return event.keyCode === 8 || event.charCode >= 48 && event.charCode <= 57">
                                <div class="invalid-feedback">
                                  Monthly Amount is required
                                </div>
                              </div>
                          </div>
                          <div class="text-right">
                              <div class="form-group col-md-12">
                                  <button type="submit" class="btn btn-primary">Save</button>
                              </div>
                          </div>
                      </div>
                    </ng-template>
                  </ngb-panel>
                </ngb-accordion>
                </form>
              </div>

              <div class="mt-2">
                <form #addAML005Receiver="ngForm" (ngSubmit)="addAML005ReceiverRule('aml005Count',addAML005Receiver.value)" [formGroup]="AML005Count">
                <ngb-accordion>
                  <ngb-panel>
                    <ng-template ngbPanelTitle>
                      <h5>AML005.2 | Transactions More Than A Set Count Done By High Risk National Sender</h5>
                    </ng-template>
                    <ng-template ngbPanelContent>
                      <div>
                        <div class="row d-flex">
                          <div class="form-group col-md-2" >
                            <input class="form-check-input" id="notify" formControlName="notify"  name="notify" style="margin-top: 10px; margin-left: 5px;" type="checkbox">
                            <label class=" col-form-label form-check-label" style="margin-left: 30px;"><i class="feather icon-bell text-warning"></i> Notify</label>
                          </div>
                          <div class="form-group col-md-1" >
                              <input class="form-check-input" id="block" formControlName="block"  name="block" style="margin-top: 10px;" type="checkbox">
                              <label class=" col-form-label form-check-label" style="margin-left: 5px;"><i class="feather icon-x-circle text-danger"></i> Block</label>
                          </div>
                        </div>
                          <div class="row d-flex">
                              <div class="form-group col-md-2">
                                  <label class="col-form-label" for="userType">Threshold Count</label>                         
                              </div>
                              <div class="form-group col-md-3" >
                                <p>Daily Count</p>
                                <input type="text" id="dailyCount" autocomplete="off" class="form-control" required formControlName="dailyCount" placeholder="Enter Daily Count" [ngClass]="{'is-invalid':submittedAML005Count && AML005Count.controls.dailyCount.errors}"  name="dailyCount" onkeypress="return event.keyCode === 8 || event.charCode >= 48 && event.charCode <= 57">
                                <div class="invalid-feedback">
                                  Daily Count is required
                                </div>
                              </div>
                              <div class="form-group col-md-3" >
                                <p>Weekly Count</p>
                                <input type="text" id="weeklyCount" autocomplete="off" class="form-control" required formControlName="weeklyCount" placeholder="Enter Weekly Count" [ngClass]="{'is-invalid':submittedAML005Count && AML005Count.controls.weeklyCount.errors}"  name="weeklyCount" onkeypress="return event.keyCode === 8 || event.charCode >= 48 && event.charCode <= 57">
                                <div class="invalid-feedback">
                                  Weekly Count is required
                                </div>
                              </div>
                              <div class="form-group col-md-3" >
                                <p>Monthly Count</p>
                                <input type="text" id="monthlyCount" autocomplete="off" class="form-control" required formControlName="monthlyCount" placeholder="Enter Monthly Count" [ngClass]="{'is-invalid':submittedAML005Count && AML005Count.controls.monthlyCount.errors}"  name="monthlyCount" onkeypress="return event.keyCode === 8 || event.charCode >= 48 && event.charCode <= 57">
                                <div class="invalid-feedback">
                                  Monthly Count is required
                                </div>
                              </div>
                          </div>
                          <div class="text-right">
                              <div class="form-group col-md-12">
                                  <button type="submit" class="btn btn-primary">Save</button>
                              </div>
                          </div>
                      </div>
                    </ng-template>
                  </ngb-panel>
                </ngb-accordion>
                </form>
              </div>

              <div class="mt-2">
                <form #addAML006Sender="ngForm" (ngSubmit)="addAML006SenderRule('aml006Amount',addAML006Sender.value)" [formGroup]="AML006Amount">
                <ngb-accordion>
                  <ngb-panel>
                    <ng-template ngbPanelTitle>
                      <h5>AML006.1 | Transactions More Than A Set Amount Received By High Risk National Receiver</h5>
                    </ng-template>
                    <ng-template ngbPanelContent>
                      <div>
                        <div class="row d-flex">
                          <div class="form-group col-md-2" >
                            <input class="form-check-input" id="notify" formControlName="notify"  name="notify" style="margin-top: 10px; margin-left: 5px;" type="checkbox">
                            <label class=" col-form-label form-check-label" style="margin-left: 30px;"><i class="feather icon-bell text-warning"></i> Notify</label>
                          </div>
                          <div class="form-group col-md-1" >
                              <input class="form-check-input" id="block" formControlName="block"  name="block" style="margin-top: 10px;" type="checkbox">
                              <label class=" col-form-label form-check-label" style="margin-left: 5px;"><i class="feather icon-x-circle text-danger"></i> Block</label>
                          </div>
                        </div>
                          <div class="row d-flex">
                              <div class="form-group col-md-2">
                                  <label class="col-form-label" for="userType">Threshold Amount</label>                         
                              </div>
                              <div class="form-group col-md-3" >
                                <p>Daily Amount</p>
                                <input type="text" id="dailyAmount" autocomplete="off" class="form-control" required formControlName="dailyAmount" placeholder="Enter Daily Amount" [ngClass]="{'is-invalid':submittedAML006Amount && AML006Amount.controls.dailyAmount.errors}"  name="dailyAmount" onkeypress="return event.keyCode === 8 || event.charCode >= 48 && event.charCode <= 57">
                                <div class="invalid-feedback">
                                  Daily Amount is required
                                </div>
                              </div>
                              <div class="form-group col-md-3" >
                                <p>Weekly Amount</p>
                                <input type="text" id="weeklyAmount" autocomplete="off" class="form-control" required formControlName="weeklyAmount" placeholder="Enter Weekly Amount" [ngClass]="{'is-invalid':submittedAML006Amount && AML006Amount.controls.weeklyAmount.errors}"  name="weeklyAmount" onkeypress="return event.keyCode === 8 || event.charCode >= 48 && event.charCode <= 57">
                                <div class="invalid-feedback">
                                  Weekly Amount is required
                                </div>
                              </div>
                              <div class="form-group col-md-3" >
                                <p>Monthly Amount</p>
                                <input type="text" id="monthlyAmount" autocomplete="off" class="form-control" required formControlName="monthlyAmount" placeholder="Enter Monthly Amount" [ngClass]="{'is-invalid':submittedAML006Amount && AML006Amount.controls.monthlyAmount.errors}"  name="monthlyAmount" onkeypress="return event.keyCode === 8 || event.charCode >= 48 && event.charCode <= 57">
                                <div class="invalid-feedback">
                                  Monthly Amount is required
                                </div>
                              </div>
                          </div>
                          <div class="text-right">
                              <div class="form-group col-md-12">
                                  <button type="submit" class="btn btn-primary">Save</button>
                              </div>
                          </div>
                      </div>
                    </ng-template>
                  </ngb-panel>
                </ngb-accordion>
                </form>
              </div>

              <div class="mt-2">
                <form #addAML006Receiver="ngForm" (ngSubmit)="addAML006ReceiverRule('aml006Count',addAML006Receiver.value)" [formGroup]="AML006Count">
                <ngb-accordion>
                  <ngb-panel>
                    <ng-template ngbPanelTitle>
                      <h5>AML006.2 | Transactions More Than A Set Count Received By High Risk National Receiver</h5>
                    </ng-template>
                    <ng-template ngbPanelContent>
                      <div>
                        <div class="row d-flex">
                          <div class="form-group col-md-2" >
                            <input class="form-check-input" id="notify" formControlName="notify"  name="notify" style="margin-top: 10px; margin-left: 5px;" type="checkbox">
                            <label class=" col-form-label form-check-label" style="margin-left: 30px;"><i class="feather icon-bell text-warning"></i> Notify</label>
                          </div>
                          <div class="form-group col-md-1" >
                              <input class="form-check-input" id="block" formControlName="block"  name="block" style="margin-top: 10px;" type="checkbox">
                              <label class=" col-form-label form-check-label" style="margin-left: 5px;"><i class="feather icon-x-circle text-danger"></i> Block</label>
                          </div>
                        </div>
                          <div class="row d-flex">
                              <div class="form-group col-md-2">
                                  <label class="col-form-label" for="userType">Threshold Count</label>                         
                              </div>
                              <div class="form-group col-md-3" >
                                <p>Daily Count</p>
                                <input type="text" id="dailyCount" autocomplete="off" class="form-control" required formControlName="dailyCount" placeholder="Enter Daily Count" [ngClass]="{'is-invalid':submittedAML006Count && AML006Count.controls.dailyCount.errors}"  name="dailyCount" onkeypress="return event.keyCode === 8 || event.charCode >= 48 && event.charCode <= 57">
                                <div class="invalid-feedback">
                                  Daily Count is required
                                </div>
                              </div>
                              <div class="form-group col-md-3" >
                                <p>Weekly Count</p>
                                <input type="text" id="weeklyCount" autocomplete="off" class="form-control" required formControlName="weeklyCount" placeholder="Enter Weekly Count" [ngClass]="{'is-invalid':submittedAML006Count && AML006Count.controls.weeklyCount.errors}"  name="weeklyCount" onkeypress="return event.keyCode === 8 || event.charCode >= 48 && event.charCode <= 57">
                                <div class="invalid-feedback">
                                  Weekly Count is required
                                </div>
                              </div>
                              <div class="form-group col-md-3" >
                                <p>Monthly Count</p>
                                <input type="text" id="monthlyCount" autocomplete="off" class="form-control" required formControlName="monthlyCount" placeholder="Enter Monthly Count" [ngClass]="{'is-invalid':submittedAML006Count && AML006Count.controls.monthlyCount.errors}"  name="monthlyCount" onkeypress="return event.keyCode === 8 || event.charCode >= 48 && event.charCode <= 57">
                                <div class="invalid-feedback">
                                  Monthly Count is required
                                </div>
                              </div>
                          </div>
                          <div class="text-right">
                              <div class="form-group col-md-12">
                                  <button type="submit" class="btn btn-primary">Save</button>
                              </div>
                          </div>
                      </div>
                    </ng-template>
                  </ngb-panel>
                </ngb-accordion>
                </form>
              </div>

              <div class="mt-2">
                <form #addAML007="ngForm" (ngSubmit)="addAML007Rule('aml007',addAML007.value)" [formGroup]="AML007">
                <ngb-accordion>
                  <ngb-panel>
                    <ng-template ngbPanelTitle>
                      <h5>AML007 | Transactions (Amount) Performed In Current Month Compared To Last few Months If Exceeds certain percentage</h5>
                    </ng-template>
                    <ng-template ngbPanelContent>
                      <div>
                        <div class="row d-flex">
                          <div class="form-group col-md-2" >
                            <input class="form-check-input" id="notify" formControlName="notify"  name="notify" style="margin-top: 10px; margin-left: 5px;" type="checkbox">
                            <label class=" col-form-label form-check-label" style="margin-left: 30px;"><i class="feather icon-bell text-warning"></i> Notify</label>
                          </div>
                          <div class="form-group col-md-1" >
                              <input class="form-check-input" id="block" formControlName="block"  name="block" style="margin-top: 10px;" type="checkbox">
                              <label class=" col-form-label form-check-label" style="margin-left: 5px;"><i class="feather icon-x-circle text-danger"></i> Block</label>
                          </div>
                        </div>
                          <div class="row d-flex">
                            <div class="form-group col-md-3" >
                              <p>Percentage</p>
                              <input type="text" id="thresholdPercentage" maxlength="3" autocomplete="off" class="form-control" required formControlName="thresholdPercentage" placeholder="Enter Percentage" [ngClass]="{'is-invalid':submittedAML007 && AML007.controls.thresholdPercentage.errors}"  name="thresholdPercentage" onkeypress="return event.keyCode === 8 || event.charCode >= 48 && event.charCode <= 57">
                              <div class="invalid-feedback">
                                Percentage is required
                              </div>
                            </div>
                              <div class="form-group col-md-3" >
                                <p>Month</p>
                                  <ng-select id="months" required formControlName="months" [ngClass]="{'is-invalid':submittedAML007 && AML007.controls.months.errors}"  name="months" placeholder="Select Month">
                                    <ng-option value="1" >1 Month</ng-option>
                                    <ng-option value="2" >2 Months</ng-option>
                                    <ng-option value="3" >3 Months</ng-option>
                                    <ng-option value="4" >4 Months</ng-option>
                                    <ng-option value="5" >5 Months</ng-option>
                                    <ng-option value="6" >6 Months</ng-option>
                                  </ng-select>
                                  <div class="invalid-feedback">
                                    Month is required
                                  </div>
                              </div>
                          </div>
                          <div class="text-right">
                              <div class="form-group col-md-12">
                                  <button type="submit" class="btn btn-primary">Save</button>
                              </div>
                          </div>
                      </div>
                    </ng-template>
                  </ngb-panel>
                </ngb-accordion>
                </form>
              </div>

              <div class="mt-2">
                <form #addAML008="ngForm" (ngSubmit)="addAML008Rule('aml008',addAML008.value)" [formGroup]="AML008">
                <ngb-accordion>
                  <ngb-panel>
                    <ng-template ngbPanelTitle>
                      <h5>AML008 | If Customer Conducts Two Or More Transactions Flipped/Switch Devices i.e. Change of Mobile device and re-register</h5>
                    </ng-template>
                    <ng-template ngbPanelContent>
                      <div>
                        <div class="row d-flex">
                          <div class="form-group col-md-2" >
                            <input class="form-check-input" id="notify" formControlName="notify"  name="notify" style="margin-top: 10px; margin-left: 5px;" type="checkbox">
                            <label class=" col-form-label form-check-label" style="margin-left: 30px;"><i class="feather icon-bell text-warning"></i> Notify</label>
                          </div>
                          <div class="form-group col-md-1" >
                              <input class="form-check-input" id="block" formControlName="block"  name="block" style="margin-top: 10px;" type="checkbox">
                              <label class=" col-form-label form-check-label" style="margin-left: 5px;"><i class="feather icon-x-circle text-danger"></i> Block</label>
                          </div>
                        </div>
                          <div class="row d-flex">
                            <div class="form-group col-md-3" >
                              <p>Number of Flip</p>
                              <input type="text" id="flipCount" autocomplete="off" class="form-control" required formControlName="flipCount" placeholder="Enter Number of Flip" [ngClass]="{'is-invalid':submittedAML008 && AML008.controls.flipCount.errors}"  name="flipCount" onkeypress="return event.keyCode === 8 || event.charCode >= 48 && event.charCode <= 57">
                              <div class="invalid-feedback">
                                Number of Flip is required
                              </div>
                            </div>
                              <div class="form-group col-md-3" >
                                <p>Month</p>
                                <ng-select id="configurableMonth" required formControlName="configurableMonth" [ngClass]="{'is-invalid':submittedAML008 && AML008.controls.configurableMonth.errors}"  name="configurableMonth" placeholder="Select Month">
                                  <ng-option value="1" >1 Month</ng-option>
                                    <ng-option value="2" >2 Months</ng-option>
                                    <ng-option value="3" >3 Months</ng-option>
                                    <ng-option value="4" >4 Months</ng-option>
                                    <ng-option value="5" >5 Months</ng-option>
                                    <ng-option value="6" >6 Months</ng-option>
                                </ng-select>
                                <div class="invalid-feedback">
                                  Month is required
                                </div>
                            </div>
                          </div>
                          <div class="text-right">
                              <div class="form-group col-md-12">
                                  <button type="submit" class="btn btn-primary">Save</button>
                              </div>
                          </div>
                      </div>
                    </ng-template>
                  </ngb-panel>
                </ngb-accordion>
                </form>
              </div>
<!-- 
              <div class="mt-2">
                <form #addAML009="ngForm" (ngSubmit)="addAML009Rule('aml009',addAML009.value)" [formGroup]="AML009">
                <ngb-accordion>
                  <ngb-panel>
                    <ng-template ngbPanelTitle>
                      <h5>AML009 | If A Receiver receives Two Or More Transactions Flipped/Switched Devices i.e. Change of Mobile device and re-register</h5>
                    </ng-template>
                    <ng-template ngbPanelContent>
                      <div>
                        <div class="row d-flex">
                          <div class="form-group col-md-2" >
                            <input class="form-check-input" id="notify" formControlName="notify"  name="notify" style="margin-top: 10px; margin-left: 5px;" type="checkbox">
                            <label class=" col-form-label form-check-label" style="margin-left: 30px;"><i class="feather icon-bell text-warning"></i> Notify</label>
                          </div>
                          <div class="form-group col-md-1" >
                              <input class="form-check-input" id="block" formControlName="block"  name="block" style="margin-top: 10px;" type="checkbox">
                              <label class=" col-form-label form-check-label" style="margin-left: 5px;"><i class="feather icon-x-circle text-danger"></i> Block</label>
                          </div>
                        </div>
                        <div class="row d-flex">
                          <div class="form-group col-md-3" >
                            <p>Number of Flip</p>
                            <input type="text" id="flipCount" autocomplete="off" class="form-control" required formControlName="flipCount" placeholder="Enter Number of Flip" [ngClass]="{'is-invalid':submittedAML009 && AML009.controls.flipCount.errors}"  name="flipCount">
                            <div class="invalid-feedback">
                              Number of Flip is required
                            </div>
                          </div>
                            <div class="form-group col-md-3" >
                              <p>Month</p>
                              <ng-select id="configurableMonth" required formControlName="configurableMonth" [ngClass]="{'is-invalid':submittedAML009 && AML009.controls.configurableMonth.errors}"  name="configurableMonth" placeholder="Select Month">
                                <ng-option value="3" >3 Month</ng-option>
                                <ng-option value="6" >6 Month</ng-option>
                              </ng-select>
                              <div class="invalid-feedback">
                                Month is required
                              </div>
                          </div>
                        </div>
                          <div class="text-right">
                              <div class="form-group col-md-12">
                                  <button type="submit" class="btn btn-primary">Save</button>
                              </div>
                          </div>
                      </div>
                    </ng-template>
                  </ngb-panel>
                </ngb-accordion>
                </form>
              </div> -->

              <div class="mt-2">
                <form #addAML010="ngForm" (ngSubmit)="addAML010Rule('aml010',addAML010.value)" [formGroup]="AML010">
                <ngb-accordion>
                  <ngb-panel>
                    <ng-template ngbPanelTitle>
                      <h5>AML010 | A Customer Receive The Fund & Immediately Sending The Fund Outward</h5>
                    </ng-template>
                    <ng-template ngbPanelContent>
                      <div>
                        <div class="row d-flex">
                          <div class="form-group col-md-2" >
                            <input class="form-check-input" id="notify" formControlName="notify"  name="notify" style="margin-top: 10px; margin-left: 5px;" type="checkbox">
                            <label class=" col-form-label form-check-label" style="margin-left: 30px;"><i class="feather icon-bell text-warning"></i> Notify</label>
                          </div>
                          <div class="form-group col-md-1" >
                              <input class="form-check-input" id="block" formControlName="block"  name="block" style="margin-top: 10px;" type="checkbox">
                              <label class=" col-form-label form-check-label" style="margin-left: 5px;"><i class="feather icon-x-circle text-danger"></i> Block</label>
                          </div>
                        </div>
                          <div class="row d-flex">
                            <div class="form-group col-md-3" >
                              <p>Threshold Amount</p>
                              <input type="text" id="thresholdAmount" autocomplete="off" class="form-control" required formControlName="thresholdAmount" placeholder="Enter Threshold Amount" [ngClass]="{'is-invalid':submittedAML010 && AML010.controls.thresholdAmount.errors}"  name="thresholdAmount" onkeypress="return event.keyCode === 8 || event.charCode >= 48 && event.charCode <= 57">
                              <div class="invalid-feedback">
                                Threshold Amount is required
                              </div>
                            </div>
                            <div class="form-group col-md-3" >
                              <p>Minute</p>
                              <input type="text" id="minutes" autocomplete="off" class="form-control" required formControlName="minutes" placeholder="Enter Minute" [ngClass]="{'is-invalid':submittedAML010 && AML010.controls.minutes.errors}"  name="minutes" onkeypress="return event.keyCode === 8 || event.charCode >= 48 && event.charCode <= 57">
                              <div class="invalid-feedback">
                                Minute is required
                              </div>
                            </div>
                            <div class="form-group col-md-3" >
                              <p>Percentage</p>
                              <input type="text" id="thresholdPercentage" maxlength="3" autocomplete="off" class="form-control" required formControlName="thresholdPercentage" placeholder="Enter Percentage" [ngClass]="{'is-invalid':submittedAML010 && AML010.controls.thresholdPercentage.errors}"  name="thresholdPercentage" onkeypress="return event.keyCode === 8 || event.charCode >= 48 && event.charCode <= 57">
                              <div class="invalid-feedback">
                                Percentage is required
                              </div>
                            </div>
                          </div>
                          <div class="text-right">
                              <div class="form-group col-md-12">
                                  <button type="submit" class="btn btn-primary">Save</button>
                              </div>
                          </div>
                      </div>
                    </ng-template>
                  </ngb-panel>
                </ngb-accordion>
                </form>
              </div>

              <div class="mt-2">
                <form #addAML013="ngForm" (ngSubmit)="addAML013Rule('aml013',addAML013.value)" [formGroup]="AML013">
                <ngb-accordion>
                  <ngb-panel>
                    <ng-template ngbPanelTitle>
                      <h5>AML013 | Customer Sending Funds To Any Other Country Than His Nationality</h5>
                    </ng-template>
                    <ng-template ngbPanelContent>
                      <div>
                        <div class="row d-flex">
                          <div class="form-group col-md-2" >
                            <input class="form-check-input" id="notify" formControlName="notify"  name="notify" style="margin-top: 10px; margin-left: 5px;" type="checkbox">
                            <label class=" col-form-label form-check-label" style="margin-left: 30px;"><i class="feather icon-bell text-warning"></i> Notify</label>
                          </div>
                          <div class="form-group col-md-1" >
                              <input class="form-check-input" id="block" formControlName="block"  name="block" style="margin-top: 10px;" type="checkbox">
                              <label class=" col-form-label form-check-label" style="margin-left: 5px;"><i class="feather icon-x-circle text-danger"></i> Block</label>
                          </div>
                        </div>
                        <div class="row d-flex">
                          <div class="form-group col-md-2">
                              <label class="col-form-label" for="userType">Threshold Amount</label>                         
                          </div>
                          <div class="form-group col-md-3" >
                            <p>Daily Amount</p>
                            <input type="text" id="dailyAmount" autocomplete="off" class="form-control" required formControlName="dailyAmount" placeholder="Enter Daily Amount" [ngClass]="{'is-invalid':submittedAML013 && AML013.controls.dailyAmount.errors}"  name="dailyAmount" onkeypress="return event.keyCode === 8 || event.charCode >= 48 && event.charCode <= 57">
                            <div class="invalid-feedback">
                              Daily Amount is required
                            </div>
                          </div>
                          <div class="form-group col-md-3" >
                            <p>Weekly Amount</p>
                            <input type="text" id="weeklyAmount" autocomplete="off" class="form-control" required formControlName="weeklyAmount" placeholder="Enter Weekly Amount" [ngClass]="{'is-invalid':submittedAML013 && AML013.controls.weeklyAmount.errors}"  name="weeklyAmount" onkeypress="return event.keyCode === 8 || event.charCode >= 48 && event.charCode <= 57">
                            <div class="invalid-feedback">
                              Weekly Amount is required
                            </div>
                          </div>
                          <div class="form-group col-md-3" >
                            <p>Monthly Amount</p>
                            <input type="text" id="monthlyAmount" autocomplete="off" class="form-control" required formControlName="monthlyAmount" placeholder="Enter Monthly Amount" [ngClass]="{'is-invalid':submittedAML013 && AML013.controls.monthlyAmount.errors}"  name="monthlyAmount" onkeypress="return event.keyCode === 8 || event.charCode >= 48 && event.charCode <= 57">
                            <div class="invalid-feedback">
                              Monthly Amount is required
                            </div>
                          </div>
                      </div>
                      <div class="row d-flex">
                        <div class="form-group col-md-2">
                            <label class="col-form-label" for="userType">Threshold Count</label>                         
                        </div>
                        <div class="form-group col-md-3" >
                          <p>Daily Count</p>
                          <input type="text" id="dailyCount" autocomplete="off" class="form-control" required formControlName="dailyCount" placeholder="Enter Daily Count" [ngClass]="{'is-invalid':submittedAML013 && AML013.controls.dailyCount.errors}"  name="dailyCount" onkeypress="return event.keyCode === 8 || event.charCode >= 48 && event.charCode <= 57">
                          <div class="invalid-feedback">
                            Daily Count is required
                          </div>
                        </div>
                        <div class="form-group col-md-3" >
                          <p>Weekly Count</p>
                          <input type="text" id="weeklyCount" autocomplete="off" class="form-control" required formControlName="weeklyCount" placeholder="Enter Weekly Count" [ngClass]="{'is-invalid':submittedAML013 && AML013.controls.weeklyCount.errors}"  name="weeklyCount" onkeypress="return event.keyCode === 8 || event.charCode >= 48 && event.charCode <= 57">
                          <div class="invalid-feedback">
                            Weekly Count is required
                          </div>
                        </div>
                        <div class="form-group col-md-3" >
                          <p>Monthly Count</p>
                          <input type="text" id="monthlyCount" autocomplete="off" class="form-control" required formControlName="monthlyCount" placeholder="Enter Monthly Count" [ngClass]="{'is-invalid':submittedAML013 && AML013.controls.monthlyCount.errors}"  name="monthlyCount" onkeypress="return event.keyCode === 8 || event.charCode >= 48 && event.charCode <= 57">
                          <div class="invalid-feedback">
                            Monthly Count is required
                          </div>
                        </div>
                      </div>
                        <div class="text-right">
                            <div class="form-group col-md-12">
                                  <button type="submit" class="btn btn-primary">Save</button>
                            </div>
                        </div>
                      </div>
                    </ng-template>
                  </ngb-panel>
                </ngb-accordion>
                </form>
              </div>

              <div class="mt-2">
                <form #addAML015="ngForm" (ngSubmit)="addAML015Rule('aml015',addAML015.value)" [formGroup]="AML015">
                <ngb-accordion>
                  <ngb-panel>
                    <ng-template ngbPanelTitle>
                      <h5>AML015 | Customers Sending Funds To Multiple Countries In A Set Period</h5>
                    </ng-template>
                    <ng-template ngbPanelContent>
                      <div>
                        <div class="row d-flex">
                          <div class="form-group col-md-2" >
                            <input class="form-check-input" id="notify" formControlName="notify"   name="notify" style="margin-top: 10px; margin-left: 5px;" type="checkbox">
                            <label class=" col-form-label form-check-label" style="margin-left: 30px;"><i class="feather icon-bell text-warning"></i> Notify</label>
                          </div>
                          <div class="form-group col-md-1" >
                              <input class="form-check-input" id="block" formControlName="block"   name="block" style="margin-top: 10px;" type="checkbox">
                              <label class=" col-form-label form-check-label" style="margin-left: 5px;"><i class="feather icon-x-circle text-danger"></i> Block</label>
                          </div>
                          <div class="form-group col-md-3" >
                            <p>Number of Country</p>
                            <input type="text" id="countries" maxlength="3" autocomplete="off" class="form-control" required formControlName="countries" placeholder="Enter Number of Country" [ngClass]="{'is-invalid':submittedAML015 && AML015.controls.countries.errors}"   name="countries" onkeypress="return event.keyCode === 8 || event.charCode >= 48 && event.charCode <= 57">
                            <div class="invalid-feedback">
                              Number of Country is required
                            </div>
                          </div>
                        </div>
                        <div class="row d-flex">
                          <div class="form-group col-md-2">
                              <label class="col-form-label" for="userType">Threshold Amount</label>                         
                          </div>
                          <div class="form-group col-md-3" >
                            <p>Daily Amount</p>
                            <input type="text" id="dailyAmount" autocomplete="off" class="form-control" required formControlName="dailyAmount" placeholder="Enter Daily Amount" [ngClass]="{'is-invalid':submittedAML015 && AML015.controls.dailyAmount.errors}"   name="dailyAmount" onkeypress="return event.keyCode === 8 || event.charCode >= 48 && event.charCode <= 57">
                            <div class="invalid-feedback">
                              Daily Amount is required
                            </div>
                          </div>
                          <div class="form-group col-md-3" >
                            <p>Weekly Amount</p>
                            <input type="text" id="weeklyAmount" autocomplete="off" class="form-control" required formControlName="weeklyAmount" placeholder="Enter Weekly Amount" [ngClass]="{'is-invalid':submittedAML015 && AML015.controls.weeklyAmount.errors}"   name="weeklyAmount" onkeypress="return event.keyCode === 8 || event.charCode >= 48 && event.charCode <= 57">
                            <div class="invalid-feedback">
                              Weekly Amount is required
                            </div>
                          </div>
                          <div class="form-group col-md-3" >
                            <p>Monthly Amount</p>
                            <input type="text" id="monthlyAmount" autocomplete="off" class="form-control" required formControlName="monthlyAmount" placeholder="Enter Monthly Amount" [ngClass]="{'is-invalid':submittedAML015 && AML015.controls.monthlyAmount.errors}"   name="monthlyAmount" onkeypress="return event.keyCode === 8 || event.charCode >= 48 && event.charCode <= 57">
                            <div class="invalid-feedback">
                              Monthly Amount is required
                            </div>
                          </div>
                      </div>
                      <div class="row d-flex">
                        <div class="form-group col-md-2">
                            <label class="col-form-label" for="userType">Threshold Count</label>                         
                        </div>
                        <div class="form-group col-md-3" >
                          <p>Daily Count</p>
                          <input type="text" id="dailyCount" autocomplete="off" class="form-control" required formControlName="dailyCount" placeholder="Enter Daily Count" [ngClass]="{'is-invalid':submittedAML015 && AML015.controls.dailyCount.errors}"   name="dailyCount" onkeypress="return event.keyCode === 8 || event.charCode >= 48 && event.charCode <= 57">
                          <div class="invalid-feedback">
                            Daily Count is required
                          </div>
                        </div>
                        <div class="form-group col-md-3" >
                          <p>Weekly Count</p>
                          <input type="text" id="weeklyCount" autocomplete="off" class="form-control" required formControlName="weeklyCount" placeholder="Enter Weekly Count" [ngClass]="{'is-invalid':submittedAML015 && AML015.controls.weeklyCount.errors}"   name="weeklyCount" onkeypress="return event.keyCode === 8 || event.charCode >= 48 && event.charCode <= 57">
                          <div class="invalid-feedback">
                            Weekly Count is required
                          </div>
                        </div>
                        <div class="form-group col-md-3" >
                          <p>Monthly Count</p>
                          <input type="text" id="monthlyCount" autocomplete="off" class="form-control" required formControlName="monthlyCount" placeholder="Enter Monthly Count" [ngClass]="{'is-invalid':submittedAML015 && AML015.controls.monthlyCount.errors}"   name="monthlyCount" onkeypress="return event.keyCode === 8 || event.charCode >= 48 && event.charCode <= 57">
                          <div class="invalid-feedback">
                            Monthly Count is required
                          </div>
                        </div>
                      </div>
                        <div class="text-right">
                            <div class="form-group col-md-12">
                                  <button type="submit" class="btn btn-primary">Save</button>
                            </div>
                        </div>
                      </div>
                    </ng-template>
                  </ngb-panel>
                </ngb-accordion>
                </form>
              </div>

              <div class="mt-2">
                <ngb-accordion>
                  <ngb-panel>
                    <ng-template ngbPanelTitle>
                      <h5>AML018 | Transaction Send By customers having nationality from Restricted / labelled countries</h5>
                    </ng-template>
                    <ng-template ngbPanelContent>
                      <div>
                        <div class="row d-flex">
                          <div class="form-group col-md-8 "></div>
                          <div class="form-group col-md-4 ">
                              <ng-select id="userType" [multiple]="true" [(ngModel)]="aml18Dropdown" placeholder="Select Label" [clearable]="false" (remove)="removeLabel('AML18',$event)" (add)="addNewLabel('AML18',$event)">
                                <ng-option *ngFor="let label of labelListAml18" value="{{label.label}}">{{label.label}}</ng-option>
                              </ng-select>
                          </div>
                        </div>
                        <div class="row d-flex">
                          <div class="form-group col-md-12 ">
                              <div class="row mb-0" style="min-height: 270px">
                                  <div class="col-12 col-xl-12 grid-margin stretch-card ag-theme-alpine" style="margin-bottom: 0px">
                                    <ag-grid-angular [enableCellTextSelection]=true (gridReady)="onGridReady($event)" 
                                      [columnDefs]="tableSelectedColumn18" [defaultColDef]="defaultColDef" [enableCellTextSelection]=true
                                       [rowData]="aml18Data" [rowModelType]="" [rowSelection]="'single'"
                                      [suppressPaginationPanel]="true" style="width: 100%; height: auto;">
                                    </ag-grid-angular>
                                  </div>
                                </div>
                          </div>
                      </div>
                      </div>
                    </ng-template>
                  </ngb-panel>
                </ngb-accordion>
              </div>

              <div class="mt-2">
                <ngb-accordion>
                  <ngb-panel>
                    <ng-template ngbPanelTitle>
                      <h5>AML019 | Transaction Received By customers having nationality from Restricted / labelled countries</h5>
                    </ng-template>
                    <ng-template ngbPanelContent>
                      <div>
                        <div class="row d-flex">
                          <div class="form-group col-md-8 "></div>
                          <div class="form-group col-md-4 ">
                              <ng-select id="userType" [multiple]="true" [(ngModel)]="aml19Dropdown" placeholder="Select Label" [clearable]="false" (remove)="removeLabel('AML19',$event)" (add)="addNewLabel('AML19',$event)">
                                <ng-option *ngFor="let label of labelListAml19" value="{{label.label}}">{{label.label}}</ng-option>
                              </ng-select>  
                          </div>
                        </div>
                        <div class="row d-flex">
                          <div class="form-group col-md-12 ">
                              <div class="row mb-0" style="min-height: 270px">
                                  <div class="col-12 col-xl-12 grid-margin stretch-card ag-theme-alpine" style="margin-bottom: 0px">
                                    <ag-grid-angular [enableCellTextSelection]=true (gridReady)="onGridReady($event)" 
                                      [columnDefs]="tableSelectedColumn19" [defaultColDef]="defaultColDef" [enableCellTextSelection]=true
                                       [rowData]="aml19Data" [rowModelType]="" [rowSelection]="'single'"
                                      [suppressPaginationPanel]="true" style="width: 100%; height: auto;">
                                    </ag-grid-angular>
                                  </div>
                                </div>
                          </div>
                      </div>
                      </div>
                    </ng-template>
                  </ngb-panel>
                </ngb-accordion>
              </div>

              <div class="mt-2">
                <form #addAML021Sender="ngForm" (ngSubmit)="addAML021SenderRule('aml021Sender',addAML021Sender.value)" [formGroup]="AML021Sender">
                <ngb-accordion>
                  <ngb-panel>
                    <ng-template ngbPanelTitle>
                      <h5>AML021.1 | Transaction From Medium Risk Countries/Jurisdictions In A Set Period</h5>
                    </ng-template>
                    <ng-template ngbPanelContent>
                      <div>
                        <div class="row d-flex">
                          <div class="form-group col-md-2" >
                            <input class="form-check-input" id="notify" formControlName="notify"   name="notify" style="margin-top: 10px; margin-left: 5px;" type="checkbox">
                            <label class=" col-form-label form-check-label" style="margin-left: 30px;"><i class="feather icon-bell text-warning"></i> Notify</label>
                          </div>
                          <div class="form-group col-md-1" >
                              <input class="form-check-input" id="block" formControlName="block"   name="block" style="margin-top: 10px;" type="checkbox">
                              <label class=" col-form-label form-check-label" style="margin-left: 5px;"><i class="feather icon-x-circle text-danger"></i> Block</label>
                          </div>
                        </div>
                        <div class="row d-flex">
                          <div class="form-group col-md-2">
                              <label class="col-form-label" for="userType">Threshold Amount</label>                         
                          </div>
                          <div class="form-group col-md-3" >
                            <p>Daily Amount</p>
                            <input type="text" id="dailyAmount" autocomplete="off" class="form-control" required formControlName="dailyAmount" placeholder="Enter Daily Amount" [ngClass]="{'is-invalid':submittedAML021Sender && AML021Sender.controls.dailyAmount.errors}"   name="dailyAmount" onkeypress="return event.keyCode === 8 || event.charCode >= 48 && event.charCode <= 57">
                            <div class="invalid-feedback">
                              Daily Amount is required
                            </div>
                          </div>
                          <div class="form-group col-md-3" >
                            <p>Weekly Amount</p>
                            <input type="text" id="weeklyAmount" autocomplete="off" class="form-control" required formControlName="weeklyAmount" placeholder="Enter Weekly Amount" [ngClass]="{'is-invalid':submittedAML021Sender && AML021Sender.controls.weeklyAmount.errors}"   name="weeklyAmount" onkeypress="return event.keyCode === 8 || event.charCode >= 48 && event.charCode <= 57">
                            <div class="invalid-feedback">
                              Weekly Amount is required
                            </div>
                          </div>
                          <div class="form-group col-md-3" >
                            <p>Monthly Amount</p>
                            <input type="text" id="monthlyAmount" autocomplete="off" class="form-control" required formControlName="monthlyAmount" placeholder="Enter Monthly Amount" [ngClass]="{'is-invalid':submittedAML021Sender && AML021Sender.controls.monthlyAmount.errors}"   name="monthlyAmount" onkeypress="return event.keyCode === 8 || event.charCode >= 48 && event.charCode <= 57">
                            <div class="invalid-feedback">
                              Monthly Amount is required
                            </div>
                          </div>
                      </div>
                      <div class="row d-flex">
                        <div class="form-group col-md-2">
                            <label class="col-form-label" for="userType">Threshold Count</label>                         
                        </div>
                        <div class="form-group col-md-3" >
                          <p>Daily Count</p>
                          <input type="text" id="dailyCount" autocomplete="off" class="form-control" required formControlName="dailyCount" placeholder="Enter Daily Count" [ngClass]="{'is-invalid':submittedAML021Sender && AML021Sender.controls.dailyCount.errors}"   name="dailyCount" onkeypress="return event.keyCode === 8 || event.charCode >= 48 && event.charCode <= 57">
                          <div class="invalid-feedback">
                            Daily Count is required
                          </div>
                        </div>
                        <div class="form-group col-md-3" >
                          <p>Weekly Count</p>
                          <input type="text" id="weeklyCount" autocomplete="off" class="form-control" required formControlName="weeklyCount" placeholder="Enter Weekly Count" [ngClass]="{'is-invalid':submittedAML021Sender && AML021Sender.controls.weeklyCount.errors}"   name="weeklyCount" onkeypress="return event.keyCode === 8 || event.charCode >= 48 && event.charCode <= 57">
                          <div class="invalid-feedback">
                            Weekly Count is required
                          </div>
                        </div>
                        <div class="form-group col-md-3" >
                          <p>Monthly Count</p>
                          <input type="text" id="monthlyCount" autocomplete="off" class="form-control" required formControlName="monthlyCount" placeholder="Enter Monthly Count" [ngClass]="{'is-invalid':submittedAML021Sender && AML021Sender.controls.monthlyCount.errors}"   name="monthlyCount" onkeypress="return event.keyCode === 8 || event.charCode >= 48 && event.charCode <= 57">
                          <div class="invalid-feedback">
                            Monthly Count is required
                          </div>
                        </div>
                      </div>
                        <div class="text-right">
                            <div class="form-group col-md-12">
                                  <button type="submit" class="btn btn-primary">Save</button>
                            </div>
                        </div>
                      </div>
                    </ng-template>
                  </ngb-panel>
                </ngb-accordion>
                </form>
              </div>

              <div class="mt-2">
                <form #addAML021Receiver="ngForm" (ngSubmit)="addAML021ReceiverRule('aml021Receiver',addAML021Receiver.value)" [formGroup]="AML021Receiver">
                <ngb-accordion>
                  <ngb-panel>
                    <ng-template ngbPanelTitle>
                      <h5>AML021.2 | Transaction To Medium Risk Countries/Jurisdictions In A Set Period</h5>
                    </ng-template>
                    <ng-template ngbPanelContent>
                      <div>
                        <div class="row d-flex">
                          <div class="form-group col-md-2" >
                            <input class="form-check-input" id="notify" formControlName="notify"   name="notify" style="margin-top: 10px; margin-left: 5px;" type="checkbox">
                            <label class=" col-form-label form-check-label" style="margin-left: 30px;"><i class="feather icon-bell text-warning"></i> Notify</label>
                          </div>
                          <div class="form-group col-md-1" >
                              <input class="form-check-input" id="block" formControlName="block"   name="block" style="margin-top: 10px;" type="checkbox">
                              <label class=" col-form-label form-check-label" style="margin-left: 5px;"><i class="feather icon-x-circle text-danger"></i> Block</label>
                          </div>
                        </div>
                        <div class="row d-flex">
                          <div class="form-group col-md-2">
                              <label class="col-form-label" for="userType">Threshold Amount</label>                         
                          </div>
                          <div class="form-group col-md-3" >
                            <p>Daily Amount</p>
                            <input type="text" id="dailyAmount" autocomplete="off" class="form-control" required formControlName="dailyAmount" placeholder="Enter Daily Amount" [ngClass]="{'is-invalid':submittedAML021Receiver && AML021Receiver.controls.dailyAmount.errors}"   name="dailyAmount" onkeypress="return event.keyCode === 8 || event.charCode >= 48 && event.charCode <= 57">
                            <div class="invalid-feedback">
                              Daily Amount is required
                            </div>
                          </div>
                          <div class="form-group col-md-3" >
                            <p>Weekly Amount</p>
                            <input type="text" id="weeklyAmount" autocomplete="off" class="form-control" required formControlName="weeklyAmount" placeholder="Enter Weekly Amount" [ngClass]="{'is-invalid':submittedAML021Receiver && AML021Receiver.controls.weeklyAmount.errors}"   name="weeklyAmount" onkeypress="return event.keyCode === 8 || event.charCode >= 48 && event.charCode <= 57">
                            <div class="invalid-feedback">
                              Weekly Amount is required
                            </div>
                          </div>
                          <div class="form-group col-md-3" >
                            <p>Monthly Amount</p>
                            <input type="text" id="monthlyAmount" autocomplete="off" class="form-control" required formControlName="monthlyAmount" placeholder="Enter Monthly Amount" [ngClass]="{'is-invalid':submittedAML021Receiver && AML021Receiver.controls.monthlyAmount.errors}"   name="monthlyAmount" onkeypress="return event.keyCode === 8 || event.charCode >= 48 && event.charCode <= 57">
                            <div class="invalid-feedback">
                              Monthly Amount is required
                            </div>
                          </div>
                      </div>
                      <div class="row d-flex">
                        <div class="form-group col-md-2">
                            <label class="col-form-label" for="userType">Threshold Count</label>                         
                        </div>
                        <div class="form-group col-md-3" >
                          <p>Daily Count</p>
                          <input type="text" id="dailyCount" autocomplete="off" class="form-control" required formControlName="dailyCount" placeholder="Enter Daily Count" [ngClass]="{'is-invalid':submittedAML021Receiver && AML021Receiver.controls.dailyCount.errors}"   name="dailyCount" onkeypress="return event.keyCode === 8 || event.charCode >= 48 && event.charCode <= 57">
                          <div class="invalid-feedback">
                            Daily Count is required
                          </div>
                        </div>
                        <div class="form-group col-md-3" >
                          <p>Weekly Count</p>
                          <input type="text" id="weeklyCount" autocomplete="off" class="form-control" required formControlName="weeklyCount" placeholder="Enter Weekly Count" [ngClass]="{'is-invalid':submittedAML021Receiver && AML021Receiver.controls.weeklyCount.errors}"   name="weeklyCount" onkeypress="return event.keyCode === 8 || event.charCode >= 48 && event.charCode <= 57">
                          <div class="invalid-feedback">
                            Weekly Count is required
                          </div>
                        </div>
                        <div class="form-group col-md-3" >
                          <p>Monthly Count</p>
                          <input type="text" id="monthlyCount" autocomplete="off" class="form-control" required formControlName="monthlyCount" placeholder="Enter Monthly Count" [ngClass]="{'is-invalid':submittedAML021Receiver && AML021Receiver.controls.monthlyCount.errors}"   name="monthlyCount" onkeypress="return event.keyCode === 8 || event.charCode >= 48 && event.charCode <= 57">
                          <div class="invalid-feedback">
                            Monthly Count is required
                          </div>
                        </div>
                      </div>
                        <div class="text-right">
                            <div class="form-group col-md-12">
                                  <button type="submit" class="btn btn-primary">Save</button>
                            </div>
                        </div>
                      </div>
                    </ng-template>
                  </ngb-panel>
                </ngb-accordion>
                </form>
              </div>

              <div class="mt-2">
                <form #addAML023="ngForm" (ngSubmit)="addAML023Rule('aml023',addAML023.value)" [formGroup]="AML023">
                <ngb-accordion>
                  <ngb-panel>
                    <ng-template ngbPanelTitle>
                      <h5>AML023 | Transaction To Mobile Wallet to Mobile Wallet i.e. Pay10 to Pay10 (Set Limit Count)</h5>
                    </ng-template>
                    <ng-template ngbPanelContent>
                      <div>
                        <div class="row d-flex">
                          <div class="form-group col-md-2" >
                            <input class="form-check-input" id="notify" formControlName="notify"   name="notify" style="margin-top: 10px; margin-left: 5px;" type="checkbox">
                            <label class=" col-form-label form-check-label" style="margin-left: 30px;"><i class="feather icon-bell text-warning"></i> Notify</label>
                          </div>
                          <div class="form-group col-md-1" >
                              <input class="form-check-input" id="block" formControlName="block"   name="block" style="margin-top: 10px;" type="checkbox">
                              <label class=" col-form-label form-check-label" style="margin-left: 5px;"><i class="feather icon-x-circle text-danger"></i> Block</label>
                          </div>
                        </div>
                        <div class="row d-flex">
                          <div class="form-group col-md-2">
                              <label class="col-form-label" for="userType">Threshold Amount</label>                         
                          </div>
                          <div class="form-group col-md-3" >
                            <p>Daily Amount</p>
                            <input type="text" id="dailyAmount" autocomplete="off" class="form-control" required formControlName="dailyAmount" placeholder="Enter Daily Amount" [ngClass]="{'is-invalid':submittedAML023 && AML023.controls.dailyAmount.errors}"   name="dailyAmount" onkeypress="return event.keyCode === 8 || event.charCode >= 48 && event.charCode <= 57">
                            <div class="invalid-feedback">
                              Daily Amount is required
                            </div>
                          </div>
                          <div class="form-group col-md-3" >
                            <p>Weekly Amount</p>
                            <input type="text" id="weeklyAmount" autocomplete="off" class="form-control" required formControlName="weeklyAmount" placeholder="Enter Weekly Amount" [ngClass]="{'is-invalid':submittedAML023 && AML023.controls.weeklyAmount.errors}"   name="weeklyAmount" onkeypress="return event.keyCode === 8 || event.charCode >= 48 && event.charCode <= 57">
                            <div class="invalid-feedback">
                              Weekly Amount is required
                            </div>
                          </div>
                          <div class="form-group col-md-3" >
                            <p>Monthly Amount</p>
                            <input type="text" id="monthlyAmount" autocomplete="off" class="form-control" required formControlName="monthlyAmount" placeholder="Enter Monthly Amount" [ngClass]="{'is-invalid':submittedAML023 && AML023.controls.monthlyAmount.errors}"   name="monthlyAmount" onkeypress="return event.keyCode === 8 || event.charCode >= 48 && event.charCode <= 57">
                            <div class="invalid-feedback">
                              Monthly Amount is required
                            </div>
                          </div>
                      </div>
                      <div class="row d-flex">
                        <div class="form-group col-md-2">
                            <label class="col-form-label" for="userType">Threshold Count</label>                         
                        </div>
                        <div class="form-group col-md-3" >
                          <p>Daily Count</p>
                          <input type="text" id="dailyCount" autocomplete="off" class="form-control" required formControlName="dailyCount" placeholder="Enter Daily Count" [ngClass]="{'is-invalid':submittedAML023 && AML023.controls.dailyCount.errors}"   name="dailyCount" onkeypress="return event.keyCode === 8 || event.charCode >= 48 && event.charCode <= 57">
                          <div class="invalid-feedback">
                            Daily Count is required
                          </div>
                        </div>
                        <div class="form-group col-md-3" >
                          <p>Weekly Count</p>
                          <input type="text" id="weeklyCount" autocomplete="off" class="form-control" required formControlName="weeklyCount" placeholder="Enter Weekly Count" [ngClass]="{'is-invalid':submittedAML023 && AML023.controls.weeklyCount.errors}"   name="weeklyCount" onkeypress="return event.keyCode === 8 || event.charCode >= 48 && event.charCode <= 57">
                          <div class="invalid-feedback">
                            Weekly Count is required
                          </div>
                        </div>
                        <div class="form-group col-md-3" >
                          <p>Monthly Count</p>
                          <input type="text" id="monthlyCount" autocomplete="off" class="form-control" required formControlName="monthlyCount" placeholder="Enter Monthly Count" [ngClass]="{'is-invalid':submittedAML023 && AML023.controls.monthlyCount.errors}"   name="monthlyCount" onkeypress="return event.keyCode === 8 || event.charCode >= 48 && event.charCode <= 57">
                          <div class="invalid-feedback">
                            Monthly Count is required
                          </div>
                        </div>
                      </div>
                        <div class="text-right">
                            <div class="form-group col-md-12">
                                  <button type="submit" class="btn btn-primary">Save</button>
                            </div>
                        </div>
                      </div>
                    </ng-template>
                  </ngb-panel>
                </ngb-accordion>
                </form>
              </div>

              <div class="mt-2">
                <form #addAML026Sender="ngForm" (ngSubmit)="addAML026SenderRule('aml026Sender',addAML026Sender.value)" [formGroup]="AML026Sender">
                <ngb-accordion>
                  <ngb-panel>
                    <ng-template ngbPanelTitle>
                      <h5>AML026.1 | New account Customer Sending Large Amount of Funds within the first 30 days (Set Limit Count)</h5>
                    </ng-template>
                    <ng-template ngbPanelContent>
                      <div>
                        <div class="row d-flex">
                          <div class="form-group col-md-2" >
                            <input class="form-check-input" id="notify" formControlName="notify"   name="notify" style="margin-top: 10px; margin-left: 5px;" type="checkbox">
                            <label class=" col-form-label form-check-label" style="margin-left: 30px;"><i class="feather icon-bell text-warning"></i> Notify</label>
                          </div>
                          <div class="form-group col-md-1" >
                              <input class="form-check-input" id="block" formControlName="block"   name="block" style="margin-top: 10px;" type="checkbox">
                              <label class=" col-form-label form-check-label" style="margin-left: 5px;"><i class="feather icon-x-circle text-danger"></i> Block</label>
                          </div>
                        </div>
                        <div class="row d-flex">
                          <div class="form-group col-md-2">
                              <label class="col-form-label" for="userType">Threshold Amount</label>                         
                          </div>
                          <div class="form-group col-md-3" >
                            <p>Daily Amount</p>
                            <input type="text" id="dailyAmount" autocomplete="off" class="form-control" required formControlName="dailyAmount" placeholder="Enter Daily Amount" [ngClass]="{'is-invalid':submittedAML026Sender && AML026Sender.controls.dailyAmount.errors}"   name="dailyAmount" onkeypress="return event.keyCode === 8 || event.charCode >= 48 && event.charCode <= 57">
                            <div class="invalid-feedback">
                              Daily Amount is required
                            </div>
                          </div>
                          <div class="form-group col-md-3" >
                            <p>Weekly Amount</p>
                            <input type="text" id="weeklyAmount" autocomplete="off" class="form-control" required formControlName="weeklyAmount" placeholder="Enter Weekly Amount" [ngClass]="{'is-invalid':submittedAML026Sender && AML026Sender.controls.weeklyAmount.errors}"   name="weeklyAmount" onkeypress="return event.keyCode === 8 || event.charCode >= 48 && event.charCode <= 57">
                            <div class="invalid-feedback">
                              Weekly Amount is required
                            </div>
                          </div>
                          <div class="form-group col-md-3" >
                            <p>Monthly Amount</p>
                            <input type="text" id="monthlyAmount" autocomplete="off" class="form-control" required formControlName="monthlyAmount" placeholder="Enter Monthly Amount" [ngClass]="{'is-invalid':submittedAML026Sender && AML026Sender.controls.monthlyAmount.errors}"   name="monthlyAmount" onkeypress="return event.keyCode === 8 || event.charCode >= 48 && event.charCode <= 57">
                            <div class="invalid-feedback">
                              Monthly Amount is required
                            </div>
                          </div>
                      </div>
                      <div class="row d-flex">
                        <div class="form-group col-md-2">
                            <label class="col-form-label" for="userType">Threshold Count</label>                         
                        </div>
                        <div class="form-group col-md-3" >
                          <p>Daily Count</p>
                          <input type="text" id="dailyCount" autocomplete="off" class="form-control" required formControlName="dailyCount" placeholder="Enter Daily Count" [ngClass]="{'is-invalid':submittedAML026Sender && AML026Sender.controls.dailyCount.errors}"   name="dailyCount" onkeypress="return event.keyCode === 8 || event.charCode >= 48 && event.charCode <= 57">
                          <div class="invalid-feedback">
                            Daily Count is required
                          </div>
                        </div>
                        <div class="form-group col-md-3" >
                          <p>Weekly Count</p>
                          <input type="text" id="weeklyCount" autocomplete="off" class="form-control" required formControlName="weeklyCount" placeholder="Enter Weekly Count" [ngClass]="{'is-invalid':submittedAML026Sender && AML026Sender.controls.weeklyCount.errors}"   name="weeklyCount" onkeypress="return event.keyCode === 8 || event.charCode >= 48 && event.charCode <= 57">
                          <div class="invalid-feedback">
                            Weekly Count is required
                          </div>
                        </div>
                        <div class="form-group col-md-3" >
                          <p>Monthly Count</p>
                          <input type="text" id="monthlyCount" autocomplete="off" class="form-control" required formControlName="monthlyCount" placeholder="Enter Monthly Count" [ngClass]="{'is-invalid':submittedAML026Sender && AML026Sender.controls.monthlyCount.errors}"   name="monthlyCount" onkeypress="return event.keyCode === 8 || event.charCode >= 48 && event.charCode <= 57">
                          <div class="invalid-feedback">
                            Monthly Count is required
                          </div>
                        </div>
                      </div>
                        <div class="text-right">
                            <div class="form-group col-md-12">
                                  <button type="submit" class="btn btn-primary">Save</button>
                            </div>
                        </div>
                      </div>
                    </ng-template>
                  </ngb-panel>
                </ngb-accordion>
                </form>
              </div>

              <div class="mt-2">
                <form #addAML026Receiver="ngForm" (ngSubmit)="addAML026ReceiverRule('aml026Receiver',addAML026Receiver.value)" [formGroup]="AML026Receiver">
                <ngb-accordion>
                  <ngb-panel>
                    <ng-template ngbPanelTitle>
                      <h5>AML026.2 | New account Customer Receiving Large Amount of Funds within the first 30 days (Set Limit Count)</h5>
                    </ng-template>
                    <ng-template ngbPanelContent>
                      <div>
                        <div class="row d-flex">
                          <div class="form-group col-md-2" >
                            <input class="form-check-input" id="notify" formControlName="notify"   name="notify" style="margin-top: 10px; margin-left: 5px;" type="checkbox">
                            <label class=" col-form-label form-check-label" style="margin-left: 30px;"><i class="feather icon-bell text-warning"></i> Notify</label>
                          </div>
                          <div class="form-group col-md-1" >
                              <input class="form-check-input" id="block" formControlName="block"   name="block" style="margin-top: 10px;" type="checkbox">
                              <label class=" col-form-label form-check-label" style="margin-left: 5px;"><i class="feather icon-x-circle text-danger"></i> Block</label>
                          </div>
                        </div>
                        <div class="row d-flex">
                          <div class="form-group col-md-2">
                              <label class="col-form-label" for="userType">Threshold Amount</label>                         
                          </div>
                          <div class="form-group col-md-3" >
                            <p>Daily Amount</p>
                            <input type="text" id="dailyAmount" autocomplete="off" class="form-control" required formControlName="dailyAmount" placeholder="Enter Daily Amount" [ngClass]="{'is-invalid':submittedAML026Receiver && AML026Receiver.controls.dailyAmount.errors}"   name="dailyAmount" onkeypress="return event.keyCode === 8 || event.charCode >= 48 && event.charCode <= 57">
                            <div class="invalid-feedback">
                              Daily Amount is required
                            </div>
                          </div>
                          <div class="form-group col-md-3" >
                            <p>Weekly Amount</p>
                            <input type="text" id="weeklyAmount" autocomplete="off" class="form-control" required formControlName="weeklyAmount" placeholder="Enter Weekly Amount" [ngClass]="{'is-invalid':submittedAML026Receiver && AML026Receiver.controls.weeklyAmount.errors}"   name="weeklyAmount" onkeypress="return event.keyCode === 8 || event.charCode >= 48 && event.charCode <= 57">
                            <div class="invalid-feedback">
                              Weekly Amount is required
                            </div>
                          </div>
                          <div class="form-group col-md-3" >
                            <p>Monthly Amount</p>
                            <input type="text" id="monthlyAmount" autocomplete="off" class="form-control" required formControlName="monthlyAmount" placeholder="Enter Monthly Amount" [ngClass]="{'is-invalid':submittedAML026Receiver && AML026Receiver.controls.monthlyAmount.errors}"   name="monthlyAmount" onkeypress="return event.keyCode === 8 || event.charCode >= 48 && event.charCode <= 57">
                            <div class="invalid-feedback">
                              Monthly Amount is required
                            </div>
                          </div>
                      </div>
                      <div class="row d-flex">
                        <div class="form-group col-md-2">
                            <label class="col-form-label" for="userType">Threshold Count</label>                         
                        </div>
                        <div class="form-group col-md-3" >
                          <p>Daily Count</p>
                          <input type="text" id="dailyCount" autocomplete="off" class="form-control" required formControlName="dailyCount" placeholder="Enter Daily Count" [ngClass]="{'is-invalid':submittedAML026Receiver && AML026Receiver.controls.dailyCount.errors}"   name="dailyCount" onkeypress="return event.keyCode === 8 || event.charCode >= 48 && event.charCode <= 57">
                          <div class="invalid-feedback">
                            Daily Count is required
                          </div>
                        </div>
                        <div class="form-group col-md-3" >
                          <p>Weekly Count</p>
                          <input type="text" id="weeklyCount" autocomplete="off" class="form-control" required formControlName="weeklyCount" placeholder="Enter Weekly Count" [ngClass]="{'is-invalid':submittedAML026Receiver && AML026Receiver.controls.weeklyCount.errors}"   name="weeklyCount" onkeypress="return event.keyCode === 8 || event.charCode >= 48 && event.charCode <= 57">
                          <div class="invalid-feedback">
                            Weekly Count is required
                          </div>
                        </div>
                        <div class="form-group col-md-3" >
                          <p>Monthly Count</p>
                          <input type="text" id="monthlyCount" autocomplete="off" class="form-control" required formControlName="monthlyCount" placeholder="Enter Monthly Count" [ngClass]="{'is-invalid':submittedAML026Receiver && AML026Receiver.controls.monthlyCount.errors}"   name="monthlyCount" onkeypress="return event.keyCode === 8 || event.charCode >= 48 && event.charCode <= 57">
                          <div class="invalid-feedback">
                            Monthly Count is required
                          </div>
                        </div>
                      </div>

                        <div class="text-right">
                            <div class="form-group col-md-12">
                                  <button type="submit" class="btn btn-primary">Save</button>
                            </div>
                        </div>
                      </div>
                    </ng-template>
                  </ngb-panel>
                </ngb-accordion>
                </form>
              </div>

              <div class="mt-2">
                <form #addAML027="ngForm" (ngSubmit)="addAML027Rule('aml027',addAML027.value)" [formGroup]="AML027">
                <ngb-accordion>
                  <ngb-panel>
                    <ng-template ngbPanelTitle>
                      <h5>AML027 | Customers structuring or large transfer transactions overseas to a single party</h5>
                    </ng-template>
                    <ng-template ngbPanelContent>
                      <div>
                        <div class="row d-flex">
                          <div class="form-group col-md-2" >
                            <input class="form-check-input" id="notify" formControlName="notify"   name="notify" style="margin-top: 10px; margin-left: 5px;" type="checkbox">
                            <label class=" col-form-label form-check-label" style="margin-left: 30px;"><i class="feather icon-bell text-warning"></i> Notify</label>
                          </div>
                          <div class="form-group col-md-1" >
                              <input class="form-check-input" id="block" formControlName="block"   name="block" style="margin-top: 10px;" type="checkbox">
                              <label class=" col-form-label form-check-label" style="margin-left: 5px;"><i class="feather icon-x-circle text-danger"></i> Block</label>
                          </div>
                        </div>
                        <div class="row d-flex">
                          <div class="form-group col-md-2">
                              <label class="col-form-label" for="userType">Threshold Amount</label>                         
                          </div>
                          <div class="form-group col-md-3" >
                            <p>Daily Amount</p>
                            <input type="text" id="dailyAmount" autocomplete="off" class="form-control" required formControlName="dailyAmount" placeholder="Enter Daily Amount" [ngClass]="{'is-invalid':submittedAML027 && AML027.controls.dailyAmount.errors}"   name="dailyAmount" onkeypress="return event.keyCode === 8 || event.charCode >= 48 && event.charCode <= 57">
                            <div class="invalid-feedback">
                              Daily Amount is required
                            </div>
                          </div>
                          <div class="form-group col-md-3" >
                            <p>Weekly Amount</p>
                            <input type="text" id="weeklyAmount" autocomplete="off" class="form-control" required formControlName="weeklyAmount" placeholder="Enter Weekly Amount" [ngClass]="{'is-invalid':submittedAML027 && AML027.controls.weeklyAmount.errors}"   name="weeklyAmount" onkeypress="return event.keyCode === 8 || event.charCode >= 48 && event.charCode <= 57">
                            <div class="invalid-feedback">
                              Weekly Amount is required
                            </div>
                          </div>
                          <div class="form-group col-md-3" >
                            <p>Monthly Amount</p>
                            <input type="text" id="monthlyAmount" autocomplete="off" class="form-control" required formControlName="monthlyAmount" placeholder="Enter Monthly Amount" [ngClass]="{'is-invalid':submittedAML027 && AML027.controls.monthlyAmount.errors}"   name="monthlyAmount" onkeypress="return event.keyCode === 8 || event.charCode >= 48 && event.charCode <= 57">
                            <div class="invalid-feedback">
                              Monthly Amount is required
                            </div>
                          </div>
                      </div>
                      <div class="row d-flex">
                        <div class="form-group col-md-2">
                            <label class="col-form-label" for="userType">Threshold Count</label>                         
                        </div>
                        <div class="form-group col-md-3" >
                          <p>Daily Count</p>
                          <input type="text" id="dailyCount" autocomplete="off" class="form-control" required formControlName="dailyCount" placeholder="Enter Daily Count" [ngClass]="{'is-invalid':submittedAML027 && AML027.controls.dailyCount.errors}"   name="dailyCount" onkeypress="return event.keyCode === 8 || event.charCode >= 48 && event.charCode <= 57">
                          <div class="invalid-feedback">
                            Daily Count is required
                          </div>
                        </div>
                        <div class="form-group col-md-3" >
                          <p>Weekly Count</p>
                          <input type="text" id="weeklyCount" autocomplete="off" class="form-control" required formControlName="weeklyCount" placeholder="Enter Weekly Count" [ngClass]="{'is-invalid':submittedAML027 && AML027.controls.weeklyCount.errors}"   name="weeklyCount" onkeypress="return event.keyCode === 8 || event.charCode >= 48 && event.charCode <= 57">
                          <div class="invalid-feedback">
                            Weekly Count is required
                          </div>
                        </div>
                        <div class="form-group col-md-3" >
                          <p>Monthly Count</p>
                          <input type="text" id="monthlyCount" autocomplete="off" class="form-control" required formControlName="monthlyCount" placeholder="Enter Monthly Count" [ngClass]="{'is-invalid':submittedAML027 && AML027.controls.monthlyCount.errors}"   name="monthlyCount" onkeypress="return event.keyCode === 8 || event.charCode >= 48 && event.charCode <= 57">
                          <div class="invalid-feedback">
                            Monthly Count is required
                          </div>
                        </div>
                      </div>

                        <div class="text-right">
                            <div class="form-group col-md-12">
                                  <button type="submit" class="btn btn-primary">Save</button>
                            </div>
                        </div>
                      </div>
                    </ng-template>
                  </ngb-panel>
                </ngb-accordion>
                </form>
              </div>
    </div>
</div> 

<app-modal #emailConfiguration [modalConfig]="emailConfig">
  <h5 class="text-center" *ngIf="userType=='DEFAULT_CUSTOMER'">Email Configuration For Customer</h5>
  <h5 class="text-center" *ngIf="userType=='AGENT'">Email Configuration For Agent</h5>
  <hr>
  <form #emailForm="ngForm" (ngSubmit)="addEmail(userType)" [formGroup]="addEmailForm">
  <div class="row d-flex" >
      <div class="form-group col-md-4 ">
        <label class="col-form-label" for="emailInput">Email ID <span aria-hidden="true"
                class="symbol required" style="color:red;">*</span>
        </label>
        <input type="text" id="emailInput" autocomplete="off" class="form-control" required formControlName="emailInput" placeholder="Enter Email ID" [ngClass]="{'is-invalid':submitted && addEmailForm.controls.emailInput.errors}"   name="emailInput">
        <div class="invalid-feedback" style="display: block;"
          *ngIf="submitted && addEmailForm.controls?.emailInput?.errors">
          <div *ngIf="addEmailForm.controls?.emailInput?.errors?.required">
            Email Id is required.
          </div>
          <div *ngIf="addEmailForm.controls?.emailInput?.errors?.pattern">
            Please enter valid email id.
          </div>
        </div>
      </div>
      <div class="form-group col-md-2" style="margin-top: 30px;">
        <button type="submit" class="btn btn-primary">Add Email</button>
      </div>
  </div>
</form>
  <br>
  <div class="row d-flex" *ngIf="userType=='DEFAULT_CUSTOMER'">
    <div class="form-group col-md-12 ">
        <div class="row mb-0" style="min-height: 270px">
            <div class="col-12 col-xl-12 grid-margin stretch-card ag-theme-alpine" style="margin-bottom: 0px">
              <ag-grid-angular [enableCellTextSelection]=true (gridReady)="onGridReady($event)" 
                [columnDefs]="tableSelectedColumnEmail" [enableCellTextSelection]=true
                 [rowData]="emailListCustomer" [rowModelType]="" [rowSelection]="'single'"
                [suppressPaginationPanel]="true" style="width: 100%; height: auto;">
              </ag-grid-angular>
            </div>
          </div>
    </div>
</div>
<div class="row d-flex" *ngIf="userType=='AGENT'">
  <div class="form-group col-md-12 ">
      <div class="row mb-0" style="min-height: 270px">
          <div class="col-12 col-xl-12 grid-margin stretch-card ag-theme-alpine" style="margin-bottom: 0px">
            <ag-grid-angular [enableCellTextSelection]=true (gridReady)="onGridReady($event)" 
              [columnDefs]="tableSelectedColumnEmail" [enableCellTextSelection]=true
               [rowData]="emailListAgent" [rowModelType]="" [rowSelection]="'single'"
              [suppressPaginationPanel]="true" style="width: 100%; height: auto;">
            </ag-grid-angular>
          </div>
        </div>
  </div>
</div>
</app-modal>